/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CommentList = {
    type: 'array',
    contains: {
        type: 'Comment',
    },
} as const;
